import { PopupHeaderClose } from "./PopupHeader.Close.js";
import { PopupHeaderContent } from "./PopupHeader.Content.js";
import { PopupHeaderDescription } from "./PopupHeader.Description.js";
import { PopupHeaderRoot } from "./PopupHeader.Root.js";
import { PopupHeaderTitle } from "./PopupHeader.Title.js";
const PopupHeader = {
    Root: PopupHeaderRoot,
    Content: PopupHeaderContent,
    Title: PopupHeaderTitle,
    Description: PopupHeaderDescription,
    Close: PopupHeaderClose
};
export { PopupHeader };
